import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { RootState } from '../../../../@types/RootState';

export type RegisterLimitSelectType = 'infoPriceSensibility' | 'infoPriceAbcClass' | 'infoPriceGlobalAbcClass' | 'sensibilityType' | 'abcClass';

export type RegisterLimitSegmentData = { value: Record<RegisterLimitSelectType, string[]> };

const initialSegmentData: RegisterLimitSegmentData = {
  value: {
    infoPriceSensibility: [],
    infoPriceAbcClass: [],
    infoPriceGlobalAbcClass: [],
    sensibilityType: [],
    abcClass: [],
  },
};

export type RegisterLimitSegmentStore = {
  selectType: RegisterLimitSelectType | null;
  data: RegisterLimitSegmentData;
};

const initialState: RegisterLimitSegmentStore = {
  selectType: null,
  data: initialSegmentData,
};

const slice = createSlice({
  name: 'ipa/limits/segment',
  initialState,
  reducers: {
    resetSegment: state => {
      state.data = initialSegmentData;
    },
    resetSegmentValueByKey: (state, action: PayloadAction<RegisterLimitSelectType>) => {
      state.data.value[action.payload] = [];
    },
    resetSelectType: state => {
      state.selectType = null;
    },
    setSelectType: (state, action: PayloadAction<RegisterLimitSelectType>) => {
      state.selectType = action.payload;
    },
    setSegmentValueByKey: (state, action: PayloadAction<{ key: RegisterLimitSelectType; value: string[] }>) => {
      state.data.value[action.payload.key] = action.payload.value;
    },
  },
});

export const { resetSegment, resetSegmentValueByKey, resetSelectType, setSegmentValueByKey, setSelectType } = slice.actions;

export default slice.reducer;

export const mapStateToProps = (state: RootState) => state.ipa.limits.filters.segment;

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  resetSelectType: () => dispatch(resetSelectType()),
  resetSegmentValueByKey: (key: RegisterLimitSelectType) => dispatch(resetSegmentValueByKey(key)),
  setSegmentValueByKey: (key: RegisterLimitSelectType, value: string[]) => dispatch(setSegmentValueByKey({ key, value })),
  handleSelectSelectType: (selectType: RegisterLimitSelectType) => {
    dispatch(setSelectType(selectType));
    dispatch(resetSegment());
  },
});
